export const constants = {
  FRONTEND_URL: "https://truthordarefun.com/secretmessage/",
  // FRONTEND_URL: "http://localhost:3000/",
  BACKEND_URL: "https://truthordarefun.com/secretmessage/backend/insert.php"
  // BACKEND_URL: "http://localhost:3000/backend/insert.php"
}